// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ok-c";
export var backButton = "_ok-4";
export var backIcon = "_ok-5";
export var chevronShortcut = "_ok-6";
export var container = "_ok-1";
export var editor = "_ok-8";
export var editorWrapper = "_ok-7";
export var prefix = "_ok-2";
export var searchIcon = "_ok-3";
export var suffix = "_ok-9";
export var suffixContent = "_ok-a";
export var suffixText = "_ok-b";
export var wrapper = "_ok-0";